export default __webpack_public_path__ + "static/media/DisabledCamera.00444cda.svg";